// Yoonly NL overrides - only keys that differ from regular NL translations.
// Missing keys automatically fall back to the standard "nl" locale.
const summeryYoonlyNlTranslations: any = {
    "bestPrice": {
        "description": "Door te boeken bij Yoonly ben je verzekerd van de beste prijs."
    }

};

export default summeryYoonlyNlTranslations;
